import {IPaging, IRate} from '../domains/rate.domain';
import {client} from "./index";

export const getRates = (name: string, filter: string, page: number = 1): Promise<IPaging<IRate>> =>
  client.get(`v2/billing-rates?rate_name=${name}&page_index=${page-1}&limit=100&search_query=${encodeURIComponent(filter)}`).then(response => {
    const items: IRate[] = response.data.data.map((item: any) => ({
      direction: item.direction,
      dialCode: item.destination_dial_code,
      locationName: item.destination_location_name,
      perMinuteRate: item.rate
    }));
    return {
      page: response.data.page_index+1,
      pageSize: response.data.page_size,
      totalCount: response.data.total_items,
      totalPages: Math.ceil(response.data.total_items / response.data.page_size),
      items
    };
  });
